import React, { useEffect, useState, useContext, Fragment } from "react";
import Layout from "components/sales/layoutChange/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import "components/sales/layoutChange/layout.css";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import ListFilters from "components/sales/ListFilters/ListFilters";
import {toast} from "react-toastify";

const ServiceList = ({ getBusinessItemList, businessItemData = {} }) => {
  const headers = ["Name", "Service Code", "UOM", "Status", "Approval Status", "HSN Code", "Action"];

  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const { baseUrl } = useContext(BaseUrl);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedName, setSelectedName] = useState(false);
  const [selectedCode, setSelectedCode] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getBusinessItemList(null, 'S');
      setIsLoading(false);
    })();
  }, [getBusinessItemList]);

  useEffect(() => {
    const tableData = ["service_name", "service_code", "uom", "status", "show_status", "hsn_code"];

    if (businessItemData?.resultSets?.length > 0) {
        const data = businessItemData.resultSets.map((element) =>
        Object.assign(
            {},
            ...tableData.map((key) => ({
            [key]:
                key === "status"
                ? element.status == 1
                    ? "Active"
                    : "Inactive"
                : element[key],
            })),
            {
            Action: [
                {
                    name: 'View Details',
                    link: `${baseUrl}/procurement/view-item/S/${element.id}`,
                },
                {
                    name: 'Edit Details',
                    link: `${baseUrl}/procurement/edit-item/S/${element.id}`,
                },
            ],
            }
        )
        );

        setListData(data);
        setPageCount(Math.ceil(businessItemData.total / businessItemData.per_page));
    } else {
        setListData([]);
    }
    }, [businessItemData]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getBusinessItemList(filterData, 'S', val.selected + 1);
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <>
        <Fragment>
          <Button
            onClick={filterToggle}
            className="filter-hamburger btn btn-transparent"
          >
            <img src={Images?.Filter} alt=""></img>
            {localization.showFilters}
          </Button>
        </Fragment>
        <Fragment>
          <a
            href={`${baseUrl}/procurement/create-item`}
            className="filter-hamburger btn btn-primary borderColorBox colorBox filterButton"
          >
            + Add Item
          </a>
        </Fragment>
        </>
    );
  };

  const applyFilter = async (filterData) => {

    const { name, code} = filterData;

    if(!name && !code){
      toast.error("Please select name or code to filter");
      return false;
    }

    localStorage.setItem("service_filter", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await getBusinessItemList(filterData, 'S');
    setIsLoading(false);
    filterToggle();
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  return (
    <Layout
      title="Service List"
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <div className="row table-margin">
        <div className="col-md-12">
          <TableSection
            data={listData}
            isId={true}
            headers={headers}
            pageCount={pageCount}
            srNo={businessItemData?.from}
            onPageChange={onPageChange}
          />
        </div>
        <ListFilters
          showFilter={showFilter}
          filterToggle={filterToggle}
          applyFilter={(val) => applyFilter(val)}
          setSelectedCode = {setSelectedCode}
          setSelectedName = {setSelectedName}
          item_type = 'S'
          businessItemFilter
        />
      </div>
    </Layout>
  );
};

export default ServiceList;
